import { GetServerSideProps } from 'next';
import {Cookies, GearInstance, ProfileInfoPageProps} from 'types';
import { ItemManagement } from 'containers/ItemManagement';
import { fetchRegularDataForItemManagement } from 'utils/services';

const ItemManagementPage = (props: ProfileInfoPageProps) => {
  return <ItemManagement {...props} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const cookies: Cookies = {
    parsed: context.req.cookies as Record<string, string>,
  };
  const force = !!context.query.force;
  const { activities, brands, categories, markets, colors, dimensionSets } = await fetchRegularDataForItemManagement(force, cookies);

  return {
    props: {
      gearInstance: {} as GearInstance,
      activities,
      brands,
      categories,
      markets,
      colors,
      dimensionSets,
    },
  };
};

export default ItemManagementPage;
